export enum CreditTypeEnum {
    PAYMENT = 'payment',
    UNLOAD = 'unload',
    SCHOOL_CLASS_UNLOAD = 'school_class_unload',
}
